export const enumPermisosAval = Object.freeze({
  aval_cb_depositos: 15000,
  aval_cb_retiros: 15001,
  aval_cb_pago_terceros: 15002,
  aval_cb_pago_subsidios: 15003,
  aval_cb_recaudo: 15004,
  RECAUDO_PILA: 15007,
});

export const enumPermisosAvalGestion = Object.freeze({
  aval_cb_convenios_recaudo: 15005,
});

export const enumPermisosDale = Object.freeze({
  RETIRO_OTP_DALE: 15006,
  DEPOSITO_DALE: 15008,
  PROMOCION_DALE: 15009,
});

export const enumPermisosRegistraduria = Object.freeze({
  RECAUDO_TRAMITE_REGISTRADURIA: 15010,
});

export const enumPermisosVentaSeguros = Object.freeze({
  RECAUDO_VENTA_SEGUROS_SURA: 15011,
});